import React from 'react';
import Header from '../../components/Header';
import CardIrrigacao from './card'

export default function IrrigacaoOnline() {

    return (
        <div className="containerirrigacao container-lg">

            <Header title="IRRIGAÇÃO ONLINE" />

            <div className="rowirrigacao">
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
                <CardIrrigacao />
            </div>
            <div className="bordered">
                <b>LEGENDA:</b>
                <div className="legenda">
                    <div className="itemlegenda">
                        <div className="sinalizador vermelho"></div><div className="textlegenda">dfasdfad</div>
                    </div>
                    <div className="itemlegenda">
                        <div className="sinalizador amarelo"></div><div className="textlegenda">dfasdfad</div>
                    </div>
                    <div className="itemlegenda">
                        <div className="sinalizador verde"></div><div className="textlegenda">dfasdfad</div>
                    </div>
                    <div className="itemlegenda">
                        <div className="sinalizador azul"></div><div className="textlegenda">dfasdfad</div>
                    </div>
                </div>
            </div>
        </div >
    )

}